import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../service/api_service';
import { pobDataModel } from '../../model'
import { Router } from '@angular/router'
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import * as $ from 'jquery';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-pob',
  template: require('./pob.component.html'),
  styles: []
})
export class POBComponent implements OnInit {
    private columnDefs;
    private rowHeight;
    firstDate: string;
    lastDate: string;
    api: any;
    busy: Subscription;
    columnApi: any;
    defaultColDefine;
    private gridColumnApi;
    POBReport_show: boolean = false;
    stateList: any = [];
    POBData: any = [];
    headQuarterList: any = [];
    categoryList: any = [];
    empName: any = [];
    divisionList: any = []
    ProductList: any = [];
    token:any;

    pobDataModel: pobDataModel = new pobDataModel();
    ManagerList:any;
    pob_Form = new FormGroup({
        fromDate: new FormControl('', [Validators.required]),
        toDate: new FormControl('', [Validators.required]),
        state: new FormControl('', [Validators.required]),
        hq: new FormControl('', [Validators.required]),
        employee: new FormControl('', [Validators.required]),
        product_group: new FormControl('', [Validators.required]),
        product_code: new FormControl('', [Validators.required]),

    });
   

    f_ChkNum(p_value) {
        var Num = Number(p_value);
        if(Num){
            return Num;
        }
        return 0;
    }

    static parameters = [ApiService, Router, HttpClient]
    constructor(private apiService: ApiService, private router: Router, private http: HttpClient) {
        this.apiService = apiService;
        this.columnDefs = [
            // { headerName: 'Sr. No', valueGetter: "node.rowIndex + 1", width: 80 },
            { headerName: 'Sr. No', valueGetter: params => { return params.data.StateName? params.node.rowIndex + 1: "" }, width: 80 },
            { headerName: 'State', field: "StateName", suppressSizeToFit: true ,filter: 'agTextColumnFilter'},
            { headerName: 'Date', field: "Date" ,filter: 'agTextColumnFilter'},
            { headerName: 'Employee', field: "Client_Name",filter: 'agTextColumnFilter' },
            { headerName: 'Manager', field: "Manager",filter: 'agTextColumnFilter' },
            { headerName: 'Head Qtr', field: "HQName" ,filter: 'agTextColumnFilter'},
            { headerName: 'Customer Type', field: "Type" ,filter: 'agTextColumnFilter'},
            { headerName: 'Customer name', field: "Name" ,filter: 'agTextColumnFilter'},
            { headerName: 'Product code', field: "Itemcode" ,filter: 'agTextColumnFilter'},
            { headerName: 'Product name', field: "Itemname",filter: 'agTextColumnFilter' },
            { headerName: 'POB Qty', field: "MinQty", cellStyle: { 'textAlign': "right" } ,filter: 'agTextColumnFilter'},
            { headerName: 'POB value', field: "pobValue", cellStyle: { 'textAlign': "right" } ,filter: 'agTextColumnFilter'}
        ];
        this.rowHeight = 50;
        this.defaultColDefine = { resizable: true };
    }



    ngOnInit() {
        this.token = JSON.parse(sessionStorage.getItem("currentUser"));
        this.getState();
        this.getHeadQuarterList();
        // this.getCategoryList();
        this.getEmployee();
        // this.getDivision();
        this.getPOBProductList();
        this.getManagerDetails();
        var date = new Date();
        var year = date.getFullYear();
        var month = (date.getMonth() + 1).toString().padStart(2, "0");
        this.firstDate = year + '-' + month + '-' + date.getDate().toString().padStart(2, "0");
        this.lastDate = year + '-' + month + '-' + date.getDate().toString().padStart(2, "0");
        console.log('firstDate ', this.firstDate, this.lastDate);
        this.pob_Form.controls['fromDate'].setValue(
            this.firstDate
        );
        this.pob_Form.controls['toDate'].setValue(
            this.lastDate
        );
        this.pobDataModel.employeeCode = '0';
        this.pobDataModel.stateId = 0;
        this.pobDataModel.hq = 0;
        this.pobDataModel.product_group = '0';
        this.pobDataModel.product_code = '0';
        this.pobDataModel.ManagerID='0';
        this.pobDataModel.partyType='0';
        this.pobDataModel.LoginId= this.token.id;
        
        var totalRow = { 
            "Client_Name": "Total: 0" ,
            pobValue: (0).toFixed(2),
            MinQty: 0
        };
        setTimeout(()=>{
            this.api.setPinnedBottomRowData([totalRow])
        }, 300);
        console.log('pob_Form', this.pob_Form.value);
        $('#filter-option').trigger('click');
    }

 
    onGridReady = (params) => {
        this.api = params.api;
        this.gridColumnApi = params.columnApi;
    }

    onBtnExport() {
        this.api.exportDataAsCsv({ fileName: 'POB_Report' });
    }

    onFilterTextBoxChanged() {
        this.api.setQuickFilter(document.querySelector<HTMLInputElement>('#filter-text-box')!.value);
        this.api.refreshCells();
    }


    getState() {
        this.apiService.getState().subscribe((res: any) => {
            this.stateList = res.data;
        })
    }

    getHeadQuarterList() {
        this.apiService.getHeadQuarterList().subscribe((res: any) => {
            this.headQuarterList = res.data;
        })
    }

    getCategoryList() {
        this.apiService.getCategoryList().subscribe((res: any) => {
            this.categoryList = res.data;
        })
    }

    getEmployee() {
        var data = {
            Id: this.token.id
        };
    this.apiService.getEmpDetails(data).subscribe((res: any) => {
            this.empName = res.data;
        })
    }

    getDivision() {
        this.apiService.getDivisionList().subscribe((res: any) => {
            this.divisionList = res.data;
        })
    }

    getManagerDetails() {
        var data = {
            Id: this.token.id
        };
        this.http.post('/api/Report/getManagerListForLogUnLog',data)
            .subscribe(res => {
                this.ManagerList = res;
            });
    }

    getPOBProductList(){
        this.http.post('/api/Product/GetProductListForPOB', {})
        .subscribe(res => {
            console.log('res :', res);
            this.ProductList = res;
        });        
    }

    eventHandlerPOB() {
        //this.api.showLoadingOverlay();
        this.pobDataModel.fromDate = this.pob_Form.value.fromDate;
        this.pobDataModel.toDate = this.pob_Form.value.toDate;
        var parent = this;
      //  console.log(this.pobDataModel);
       this.busy = this.apiService.getPOBData(this.pobDataModel).subscribe((res: any) => {
            this.POBData = res.data;        
            var pobValue = this.POBData.reduce(function(acc, sum){ return (acc + parent.f_ChkNum(sum.pobValue)); }, 0);
            var MinQty = this.POBData.reduce(function(acc, sum){ return (acc + parent.f_ChkNum(sum.MinQty)); }, 0);
            var DistinctEmployeeList = this.POBData.filter((x, i, a) => a.map(item => item.EmpId).indexOf(x.EmpId) === i);
            var totalRow = { 
                "Client_Name": "Total: " + DistinctEmployeeList.length ,
                pobValue: pobValue.toFixed(2),
                MinQty: MinQty
            };
            setTimeout(()=>{
                this.api.setPinnedBottomRowData([totalRow]);
            }, 300);
            console.log("POB data", res.data)
            this.POBReport_show = true;
        })
    }
}
